// extracted by mini-css-extract-plugin
module.exports = {"page-not-found":"styles_page-not-found__3BToZ","page-not-found__img":"styles_page-not-found__img__1FbZN"};